
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motivation-scan/onboarding",
      function () {
        return require("private-next-pages/motivation-scan/onboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motivation-scan/onboarding"])
      });
    }
  